const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  isPii: state => state.app.isPii,
  isEz: state => state.app.isEz,
  isID: state => state.app.isID,
  isMX: state => state.app.isMX,
  isAruxpay: state => state.app.isAruxpay,
  showPendingPopup: state => state.app.showPendingPopup,
  platform: state => state.app.platform,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  timeZone: state => state.user.timeZone,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  mainUserName: state => state.user.mainUserName,
  showDownloadList: state => state.app.showDownloadList,
  legalMobile: state => state.user.legalMobile,
  legalEmail: state => state.user.legalEmail,
  email: state => state.user.email,
  logoImgOssUrl: state => state.user.logoImgOssUrl,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  authorities: state => state.user.authorities,
  reLoginLimitTimes: state => state.user.reLoginLimitTimes,
  reLoginRouterPath: state => state.user.routerPath,
  currency: state => state.user.curCountry.currency,
  isCurIDCountry: state => state.user.curCountry.country_code === 'ID',
  isCurVNCountry: state => state.user.curCountry.country_code === 'VN',
  symbol: state => state.user.curCountry.symbol,
  curCountry: state => state.user.curCountry,
  isOpenMfa: state => state.user.isOpenMfa,
  isAgentMerchant: state => state.user.isAgentMerchant,
  isOpenFXFunction: state => state.user.mch_foreign_exchange_status,
  nsdsStatus: state => state.user.nsdsStatus,
  kycStatus: state => state.user.kycStatus,
  unreadNotificaionCount: state => state.user.unreadNotificaionCount,
  onlineCountryArr: (state, getters) => {
    let filterAttr = 'en_name'
    if (getters.language === 'zh') {
      filterAttr = 'cn_name'
    }

    const list = state.page.countryArr.map(item => {
      return { ...item, value: item.code, label: item[filterAttr] }
    })

    return list
  },
  findOnlineCountryObj: (state, getters) => (code) => {
    const item = getters.onlineCountryArr.find((item) => item.code === code)
    if (item) {
      return item
    } else {
      return {}
    }
  },
  isHasAuth: (state, getters) => (auth) => {
    const authorities = state.user.authorities
    return authorities.includes(auth)
  },
  isRussia: state => state.user.curCountry.country_code === 'RU',
  merchantCategoryArr: (state, getters) => {
    let filterAttr = 'en_name'
    if (getters.language === 'zh') {
      filterAttr = 'cn_name'
    }

    const list = state.user.merchantCategoryArr.map(item => {
      return { ...item, value: item.nm_code, label: item[filterAttr] }
    })

    return list
  },
  isIdMerchant: state => state.app.isID || (state.app.isPii && state.user.curCountry.country_code === 'ID'),
  isMyMerchant: state => state.app.isPii && state.user.curCountry.country_code === 'MY',
  isVnMerchant: state => state.app.isPii && state.user.curCountry.country_code === 'VN'
}
export default getters
